import React from 'react';
import { UHC_SliderProps } from '../Slider';
import './InputRange.scss';

export interface InputRangeProps {
    ['aria-labelledBy']: string
    pipes: UHC_SliderProps['pipes'],
    pipesDisabled?:UHC_SliderProps['pipesDisabled'],
    pipeState:UHC_SliderProps['pipeState']
}

const handleChange = (e: string, disabled:InputRangeProps['pipesDisabled'], setPipeSelected:React.Dispatch<React.SetStateAction<number>>) => {
    const result: number = +e;
    if(disabled){
        if (result < disabled.min) return;
        if (result > disabled.max) return;
    }
    setPipeSelected(result);
}

const UHC_InputRange: React.FC<InputRangeProps> = (props: InputRangeProps) => {
    const { pipes, pipeState:{pipeSelected},pipeState:{setPipeSelected},pipesDisabled } = props;
    return (
    <>
        <input
            aria-labelledby={props['aria-labelledBy']}
            data-testid='UHC_InputRangeSlide'
            className="range-slide"
            name="range"
            type="range"
            min="0"
            max={pipes.length - 1}
            value={pipeSelected}
            step="1"
            onChange={e => handleChange(e.target.value, pipesDisabled, setPipeSelected)}
        />
    </>
    );
}

export default UHC_InputRange;